import { Channel } from '@src/api/shared/community/channelApiClient';
import { createContext, useContext } from 'react';

type ChannelContextType = {
  channel: Channel;
};

export const ChannelContext = createContext<ChannelContextType | undefined>(undefined);

export const useChannel = () => {
  const context = useContext(ChannelContext);
  if (context === undefined) {
    throw new Error('useChannel must be used within a ChannelProvider');
  }
  return context;
};
